import React from 'react';
import PropTypes from 'prop-types';
import { StyledMuxPlayer } from './styles.js';

export const MuxVideo = ({
  playbackId,
  autoplay,
  loop,
  thumbnail,
  showScrollControls = false,
  aspectRatio = '4 / 3',
}) => {
  return (
    <StyledMuxPlayer
      showScrollControls={showScrollControls}
      playbackId={playbackId}
      aspectRatio={aspectRatio}
      loop={loop}
      autoPlay={autoplay}
      muted={autoplay}
      preload="auto"
      minResolution="540p"
      {...(thumbnail ? { poster: thumbnail } : {})}
    />
  );
};

MuxVideo.propTypes = {
  playbackId: PropTypes.string.isRequired,
  autoplay: PropTypes.bool,
  loop: PropTypes.bool,
  thumbnail: PropTypes.string,
  showScrollControls: PropTypes.bool,
  aspectRatio: PropTypes.string,
};
